import { useState } from 'react';
import toast from 'react-hot-toast';
import { buscarEnderecoPorCep, formatarCep } from '../utils/cep';

// Campo de CEP com botão de busca — preenche outros campos do formulário via
// callback quando a consulta (ViaCEP) tem sucesso.
export default function CepInput({ value, onChange, onEncontrado, label = 'CEP' }) {
  const [buscando, setBuscando] = useState(false);

  const buscar = async () => {
    setBuscando(true);
    try {
      const data = await buscarEnderecoPorCep(value);
      onEncontrado(data);
    } catch (err) {
      toast.error(err.message || 'Erro ao buscar CEP');
    } finally {
      setBuscando(false);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="flex gap-2">
        <input
          type="text"
          inputMode="numeric"
          placeholder="00000-000"
          className="flex-1 border border-gray-300 rounded-lg px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={value}
          onChange={e => onChange(formatarCep(e.target.value))}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); buscar(); } }}
        />
        <button type="button" onClick={buscar} disabled={buscando}
          className="px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 disabled:opacity-50 whitespace-nowrap">
          {buscando ? '...' : '🔍 Buscar'}
        </button>
      </div>
    </div>
  );
}
